"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlinedSinglePriceAware__factory = void 0;
var ethers_1 = require("ethers");
var InlinedSinglePriceAware__factory = /** @class */ (function (_super) {
    __extends(InlinedSinglePriceAware__factory, _super);
    function InlinedSinglePriceAware__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    InlinedSinglePriceAware__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    InlinedSinglePriceAware__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    InlinedSinglePriceAware__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    InlinedSinglePriceAware__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    InlinedSinglePriceAware__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    return InlinedSinglePriceAware__factory;
}(ethers_1.ContractFactory));
exports.InlinedSinglePriceAware__factory = InlinedSinglePriceAware__factory;
var _abi = [
    {
        inputs: [],
        name: "getTrustedSigner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b5060ef8061001f6000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c806319bfb5ff14602d575b600080fd5b60336047565b604051603e91906070565b60405180910390f35b600073fe71e9691b9524bc932c23d0eed5c9ce41161884905090565b606a816089565b82525050565b6000602082019050608360008301846063565b92915050565b60006092826099565b9050919050565b600073ffffffffffffffffffffffffffffffffffffffff8216905091905056fea26469706673582212201fc95186441d1acd603fd02bd997796d5291e7bb37ea1927f65025d79db35f7e64736f6c63430008040033";
//# sourceMappingURL=InlinedSinglePriceAware__factory.js.map